import { useContext, useState } from "react";
import styled from "styled-components";
import Context from "./Context";

export default function MenuPc(){
    const {setNotas,setId,videos,notas,setVideos,setMostrandoTodas,setTempo}=useContext(Context)
    
    const [op,setOp]=useState(false)
    function limitarTexto(texto, max) {
    return texto.length > max
      ? texto.slice(0, max) + '...'
      : texto
  }
  function excluir(ident){
        const nova=[]
        for(let video of videos){
        if(video.id!=ident)nova.push(video)
        }
        setVideos(nova)
        const novaNotas=[]
        for(let n of notas ){
            if(n.id!=ident)novaNotas.push(n)
        }
        setNotas(novaNotas)
    }
    return (
        <Tudo>
          <Topo>
            <p>Meus vídeos</p>
          </Topo>
          {[...videos].reverse().map(o=><Opcao
          
            onMouseEnter={() => setOp(o)}
            onMouseLeave={() => setOp(false)}
          >
            <Clicavel onClick={()=>{
            setId(o.id);setTempo(false);setMostrandoTodas(false)
          }}/>
            {op&&op.id==o.id?<Detalhes
        onMouseEnter={() => setOp(op)}
            onMouseLeave={() => setOp(false)}
        >
            
            {notas.filter(n=>n.id==o.id).map(p=><Nota
            onClick={()=>{setId(p.id);setTempo(p.num);setMostrandoTodas(false)}}
            >
              <p>{p.texto}</p>
              <p>{p.minutos}</p>
            </Nota>)}
            <footer>
            <button style={{background:'#ed7a65'}} onClick={()=>excluir(o.id)}>Excluir vídeo</button>
              </footer>
        </Detalhes>:<></>}

            <h5>{limitarTexto(o.titulo, 60)}</h5>
            <h6>{o.minutos}</h6>
            <small>{o.autor}</small>

          </Opcao>)}
        </Tudo>
    )
}
const Tudo=styled.aside`
display:flex;
width:200px;
min-height:100%;
flex-direction:column;
align-items:center;
overflow-x:visible;
@media(max-width:1150px){
display:none}
`
const Topo=styled.div`
align-items:center;
background:#2a2a3f;
width:100%;text-align:center;
position:sticky;top:0;
z-index:3;min-height:50px;
p{width:100%;color:white;font-size:16px;font-weight:300}
`
const Opcao=styled.div`
position:relative;cursor:pointer;
width:180px;
color:white;
background:royalblue;
flex-direction:column;
padding:10px;
margin-bottom:10px;
border-radius:10px;
font-size:16px;
small{font-size:13px;font-weight:300}
h5{font-size:16px;font-weight:400;margin:2px 0 0px 0;line-height:19px;}
h6{font-size:16px;font-weight:300;margin:2px 0 2px 0;}
`
const Clicavel=styled.div`
position:absolute;
cursor:pointer;
width:100%;z-index:1;
height:100%;top:0;left:0;
border-radius:10px;
`
const Detalhes=styled.div`
width:280px;
position:absolute;
top:0;z-index:5;
right:180px;
background:white;color:black;
flex-direction:column;
padding:10px;
border-radius:10px;
 transition: opacity 0.6s ease;
 h1{margin:0;font-size:15px;font-weight:500;}
 h2{margin:0;font-size:15px;font-weight:400;}
 header{
 display:flex;justify-content:space-between;
 width:100%;
 }
 footer{
 margin-top:10px;
 display:flex;
 justify-content:flex-end;
 }
 button{
width:120px;
height:40px;
border-radius:10px;border:0;
}

`
const Nota=styled.div`
background:seagreen;
justify-content:space-between;
padding:10px;color:white;
margin-top:10px;
border-radius:10px;
p{margin:0;}
`